import React, {useState, useEffect} from 'react';

import { notification, Select } from 'antd';

import { FormattedMessage, useIntl } from 'react-intl';

import _service from '@netuno/service-client';

const langContext = 'components.measurement-unit-select';

export default (props) => {
    const intl = useIntl();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(()=> {
        setLoading(true);
        _service({
            url: "/measurement-unit//list",
            success: (response) => {
                setLoading(false);
                setData(response.json);
            },
            fail: (e) => {
                notification["error"]({
                    message: intl.formatMessage({id: `${langContext}.error.message`}),
                    description: e.response.json.error,
                });
            }
        });
    }, []);
    return (
        <Select placeholder={intl.formatMessage({id: `${langContext}.placeholder`})} loading={loading} style={{width: '200px'}} {...props}>
          {
              data.map((item, key) => (
                  <Select.Option key={key} value={item.uid}>{item.description[intl.locale.split('-')[0]]}</Select.Option>
              ))
          }
        </Select>
    );
};

